/** @format */

import React, { useEffect, useState } from 'react';

import { setGlobal } from 'reactn';
import { useTranslation } from 'react-i18next';

import { GlobalConsumer } from '../../../../components/Commons/Context/Global';
import { BagConsumer } from '../../../../components/Commons/Context/Bag';

import { Row, Col, Form } from 'antd';
import { ClockCircleOutlined } from '@ant-design/icons';

import MetaDescription from '../../../../components/Commons/MetaDescription';
import Notify from '../../../../components/Commons/Notify';
// import Address from '../../../../components/Commons/Header/components/Address';

import CheckoutTimeLine from '../../../../components/CheckoutTimeLine';
import CheckoutGlobalTitle from '../../../../components/CheckoutGlobalTitle';

import { RemoveLocalStorage } from '../../../../components/HooksCheckout/Functions/RemoveLocalStorage';

import BagMainInfo from '../../components/BagMainInfo';
import BagMainInfoMobile from '../../components/BagMainInfoMobile';
// import BagAlliesInfo from '../../components/BagAlliesInfo';
import BagProductsGroup from '../../components/BagProductsGroup';
import BagError from '../../components/BagError';
// import BagBanners from '../../components/BagBanners';
import BagModalCalculate from '../../components/BagModalCalculate';

import { BagValidateDelivery } from '../../functions/BagValidateDelivery';
import { BagCalculation } from '../../functions/BagCalculation';
import BagRecipeFilter from '../../functions/BagRecipeFilter';

import BagTotal from '../../functions/BagTotal';

// import ElectronicProductcs from './components/ElectronicProductcs';
import NoProducts from './components/NoProducts';
import Loading from './components/Loading';

import { BagMerge } from '../../functions/BagMergeLocals';

import { BagServiceRME, BagServiceOnDemand } from './services';

import BagAddProduct from '../../functions/BagAddProduct';

// import HandleAddProductElectronic from '../../functions/BagAddProductElectronic';

import './style.scss';
import { useParams } from 'react-router-dom';
import AddProductCart from '../../../../components/Commons/Hooks/Functions/AddProductCart';
// import BagAddress from '../../components/BagMainInfo/components/BagAddress';
import { useHistory } from 'react-router-dom/cjs/react-router-dom.min';
import QuotationFailModal from './components/QuotationFailModal';
import { Service } from './service';

export default function BagElectronicCart(props) {
	// const [isAddedCart] = useGlobal('onDemandCart');
	console.log('props', props);
	const { t } = useTranslation('global');

	const [isType] = useState(props.match.params.type);

	const [isLocation] = useState(JSON.parse(localStorage.getItem('locationStore')));
	// ... otros estados
	const [isLoadingInitial, setIsLoadingInitial] = useState(true);
	// const [userInfo] = useState(JSON.parse(localStorage.getItem('userMainInfo')));

	const { handleAddProductsCartBulk } = AddProductCart();

	const { id } = useParams();

	const { isBag, isMobile, setBag } = GlobalConsumer();
	const {
		isBagData,
		isElectronicPrescription,
		setBagData,
		setBagRetirement,
		setBagCalculateModal,
		setBagRetirementPharmacies,
		setBagTotalCart,
		setElectronicPrescription,
		setBagRecipe,
		// setBagFilterProducts,
	} = BagConsumer();

	const history = useHistory();

	const [cartForm] = Form.useForm();

	const isBagCart = JSON.parse(localStorage.getItem('cart')) || [];

	const { handleCheckRetirement } = BagValidateDelivery();
	const { handleBagTotal } = BagTotal();

	const { handleAddProduct } = BagAddProduct();
	const [isModalVisible, setIsModalVisible] = useState(false);

	const handleCancelModal = () => {
		setIsModalVisible(false);
	};

	const handleDeleteCart = (isDelete = false) => {
		localStorage.setItem('cart', JSON.stringify([]));
		setGlobal(() => ({ carQuantity: 0 }));

		console.log('isDelete', isDelete);
		if (!isDelete) {
			history.push('/cart');
		}
	};

	useEffect(() => {
		const checkRejectedQuotation = async () => {
			try {
				if (!Array.isArray(isBagCart) || isBagCart.length === 0) return;
				console.log('Checking rejected quotation...');
				let quotationToken = null;

				for (const item of isBagCart) {
					const token = item?.interface_quotation?.quotation_token;
					if (token) {
						quotationToken = token;
						console.log('Found quotation token:', quotationToken);
						break;
					}
				}

				if (!quotationToken) return;

				const service = new Service();
				const response = await service.getBagOnDemand(quotationToken);

				if (!response) {
					Notify({
						title: `Productos inválidos`,
						colorTitle: 'ph-main-notification-error-title',
						description: `Borramos los productos de tu bolsa porque eran de una cotización cancelada o vencida.`,
						time: 6,
						image: 'error',
						placement: 'topRight',
					});

					handleDeleteCart(true);
				}
			} catch (e) {
				console.log('checkRejectedQuotation error:', e);
			}
		};

		checkRejectedQuotation();
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, []);

	useEffect(() => {
		RemoveLocalStorage();
	}, []);

	useEffect(() => {
		setBagCalculateModal(true);
		let mainBag = isBag;
		let requestService;
		if (isType === 'on_demand') requestService = BagServiceOnDemand;
		else requestService = BagServiceRME;

		requestService(props.match.params.id).then((response) => {
			if (response) {
				response.products.forEach((product) => {
					product.price = product.final_unit_price;
				});
				setElectronicPrescription(response);

				if (isType === 'on_demand') {
					// if (userInfo === null) {
					// 	return;
					// } else {
					// 	setGlobal({ address: response.user_info.location });
					// 	localStorage.setItem('locationStore', JSON.stringify(response.user_info.location));
					// }
				} else if (isType === 'refer_pharmacies') {
					let CheckStock = false;
					if (response.products.length > 0) {
						response.products.forEach((item) => {
							if (item.pharmacies?.length > 0) {
								item.pharmacies.forEach((element) => {
									const even = (product) => product.id === element.id;
									if (element.quantity > 9 || element.stock <= 0) {
										CheckStock = true;
									} else if (!isBag.some(even)) {
										mainBag = handleAddProduct(isBag, element, item.quantity ? item.quantity : 1);
									}
								});
							}
						});
					}
					if (CheckStock) {
						Notify({
							title: `¡Aviso!`,
							colorTitle: 'ph-main-notification-warning-title',
							description: `Algunos productos no pudieron ser agregados; por falta de disponibilidad o límite de compra.`,
							time: 10,
							image: 'warning',
							placement: 'topRight',
						});
					}
				} else {
					setGlobal({ address: isLocation });
				}

				if (mainBag.length > 0) {
					BagCalculation('farmacia', false).then(async (responseCalc) => {
						setBagCalculateModal(false);
						if (responseCalc) {
							const localsMerged = await BagMerge(responseCalc.locals_group);
							const responseBag = { ...responseCalc, locals_group: localsMerged };

							let checkRetirement = handleCheckRetirement(mainBag);
							setBagTotalCart(handleBagTotal(responseBag));
							let pharmacies = {};
							responseBag.locals_group.forEach((item) => {
								if (item.payment.discount !== 0) {
									Notify({
										title: `¡Bien!`,
										colorTitle: 'ph-main-notification-warning-title',
										description: `Estás disfrutando de un descuento en ${item.name_editable}. El monto se refleja al seleccionar el tipo de entrega.`,
										time: 5,
										image: 'warning',
										placement: 'topRight',
									});
								}
								pharmacies = {
									...pharmacies,
									[item.name]: item?.locals.length > 0 ? item : false,
								};
								if (pharmacies[item.name] === false) {
									checkRetirement[item.name] = {
										info: [],
										deliveryStatus: false,
										type_retirement: null,
									};
									let bag = mainBag;
									bag.forEach((element) => {
										if (item.name === element.pharmacy) delete element.type_retirement;
									});
									localStorage.setItem('cart', JSON.stringify(bag));
									setBag(bag);
								} else {
									const filter = BagRecipeFilter(mainBag);
									setBagRecipe(filter.some((item) => !item.recipe));
									// setBagFilterProducts(filter);
								}
							});
							setBagRetirement({ ...checkRetirement });
							setBagRetirementPharmacies(pharmacies);
							setBagData({ ...responseBag });
						} else {
							setBagData(false);
						}
					});
				} else {
					setBagCalculateModal(false);
				}
			} else {
				setBagCalculateModal(false);
				setElectronicPrescription(false);
				setIsLoadingInitial(false);
			}
		});
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [handleCheckRetirement, setBagRetirementPharmacies, setBagCalculateModal, setBagData, setBagRetirement, cartForm]);

	useEffect(() => {
		const syncElectronicPrescriptionToBag = async () => {
			if (isType !== 'on_demand') return;
			if (!isElectronicPrescription || !isElectronicPrescription.products) return;
			const cartNow = JSON.parse(localStorage.getItem('cart')) || [];
			if (cartNow.length < 0) {
				setIsLoadingInitial(true);
			} else setIsLoadingInitial(false);
			const itemsToAdd = [];

			let quotationToken = null;
			cartNow.forEach((item) => {
				if (item.interface_quotation) {
					quotationToken = item.interface_quotation.quotation_token;
					// Deja de buscar si ya encontramos el `quotation_token`
					return;
				}
			});

			if (quotationToken) {
				const existingProduct = isElectronicPrescription.products.find(
					(product) => product.product_detail.interface_quotation?.quotation_token === quotationToken,
				);

				if (!existingProduct) {
					setIsModalVisible(true);
					return;
				}
			}

			isElectronicPrescription.products.forEach((element) => {
				const pharmacy = { ...element.product_detail, ...element };
				if (!pharmacy) return;

				const alreadyInBag = cartNow.some((item) => item.code_internal === pharmacy.code_internal);

				if (!alreadyInBag) {
					const quantity = element.quantity || 1;
					itemsToAdd.push({ item: pharmacy, quantity });
				}
			});

			if (itemsToAdd.length === 0) return;

			handleAddProductsCartBulk(itemsToAdd, false);

			const mainBag = JSON.parse(localStorage.getItem('cart')) || [];
			if (mainBag.length === 0) return;

			setBagCalculateModal(true);

			const response = await BagCalculation('farmacia', false);

			setBagCalculateModal(false);

			if (!response) {
				setBagData(false);
				return;
			}
			const localsMerged = await BagMerge(response.locals_group);
			const responseBag = { ...response, locals_group: localsMerged };

			let checkRetirement = handleCheckRetirement(mainBag);
			setBagTotalCart(handleBagTotal(responseBag));

			let pharmacies = {};
			responseBag.locals_group.forEach((item) => {
				if (item.payment.discount !== 0) {
					Notify({
						title: `¡Bien!`,
						colorTitle: 'ph-main-notification-warning-title',
						description: `Estás disfrutando de un descuento en ${item.name_editable}. El monto se refleja al seleccionar el tipo de entrega.`,
						time: 5,
						image: 'warning',
						placement: 'topRight',
					});
				}
				pharmacies = {
					...pharmacies,
					[item.name]: item?.locals.length > 0 ? item : false,
				};
				if (pharmacies[item.name] === false) {
					checkRetirement[item.name] = {
						info: [],
						deliveryStatus: false,
						type_retirement: null,
					};
					let bag = mainBag;
					bag.forEach((element) => {
						if (item.name === element.pharmacy) delete element.type_retirement;
					});
					localStorage.setItem('cart', JSON.stringify(bag));
					setBag(bag);
				} else {
					const filter = BagRecipeFilter(mainBag);
					setBagRecipe(filter.some((item) => !item.recipe));
					// setBagFilterProducts(filter);
				}
			});

			setBagRetirement({ ...checkRetirement });
			setBagRetirementPharmacies(pharmacies);
			setBagData({ ...responseBag });
			setIsLoadingInitial(false);
			if (isBag.length > 0) {
				history.push('/cart');
			}
		};

		syncElectronicPrescriptionToBag();
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [id, isElectronicPrescription, isType]);

	if (isLoadingInitial) {
		return <Loading />;
	}

	if (isElectronicPrescription === false)
		return (
			<BagError
				data={{
					title: '¡Cotizacion vencida o cancelada!',
				}}
			/>
		);

	if (isElectronicPrescription === false && isBag.length > 0) {
		history.push('/cart');
		Notify({
			title: `¡Ups!`,
			colorTitle: 'ph-main-notification-error-title',
			description: `La cotización que estás intentando ver está vencida o cancelada.`,
			time: 8,
			image: 'warning',
			placement: 'topRight',
		});
	}

	if (isBag.length <= 0) {
		return (
			<BagError
				data={{
					title: '¡Tu Bolsa está triste!',
					description: '...aún no agregas ningún producto.',
				}}
			/>
		);
	}

	console.log('isBagDataxx', isElectronicPrescription);

	return (
		<>
			<MetaDescription title={t('main.metaTitle')} name={'description'} content={t('main.metaContent')} />
			<div className="ph-bag-electronic-global-container">
				<div className="ph-bag-electronic-main-container">
					<CheckoutTimeLine />
					{/* {isMobile && isBag.length > 0 && (
						<div className="ph-bag-main-info-main-address-title-container">
							<div className="ph-bag-main-info-main-title-container">
								<span className="ph-bag-main-info-main-title">
									{' '}
									<span style={{ fontWeight: '500' }}>Tu domicilio</span> (nos sirve para calcular si la farmacia está cerca de tu dirección)
								</span>
								<hr style={{ margin: '10px 0', borderTop: '1px #EDEDEF' }} />
							</div>
							<div>
								<BagAddress isType={isType} classType={'ph-cart-form-address'} />
							</div>
						</div>
					)} */}
					<div className="ph-bag-electronic-main-title-container">
						<CheckoutGlobalTitle title={'Tu Bolsa'} subtitle1={'Total'} subtitle2={'productos'} />
						<div className="ph-bag-electronic-countdown-static-container">
							<ClockCircleOutlined className="ph-bag-electronic-countdown-static-icon" />
							<span className="ph-bag-electronic-countdown-static-description">5:00</span>
						</div>
					</div>
					<Row>
						<Col xs={24} sm={24} md={24} lg={15} xl={15}>
							{isBag.length <= 0 ? <NoProducts /> : <>{isBagData ? <BagProductsGroup cartForm={cartForm} /> : <Loading />}</>}
						</Col>
						<Col xs={24} sm={24} md={24} lg={9} xl={9}>
							<BagMainInfo isType={isType} cartForm={cartForm} />

							{isMobile && <BagMainInfoMobile cartForm={cartForm} />}
							{/* <BagAlliesInfo /> */}
						</Col>
					</Row>
					{/* <BagBanners /> */}
				</div>
			</div>
			<QuotationFailModal visible={isModalVisible} onCancel={handleCancelModal} onDeleteCart={handleDeleteCart} />
			<BagModalCalculate />

			{/* <Address /> */}
		</>
	);
}
